<template>
	<section>
		<h4 class="card-subtitle">{{ title }}</h4>
		<label v-if="!image" class="file-upload" for="upload-image">
			<input id="upload-image" type="file" ref="file" name="upload-image" @change="handleFileUpload()">
			<span><i class="fas fa-upload"></i>&nbsp; Upload your file here.</span>
		</label>
		<div v-else>
			<img :src="image" alt="logo">
			<div class="text-center mt-1">
				<input id="change-upload-image" class="hidden" type="file" ref="fileChange" name="upload-image" @change="handleFileUpload()">
				<button class="btn btn-sm btn-primary" :disabled="inProgress" @click="$refs.fileChange.click()">Change</button>
			</div>
		</div>
	</section>
</template>

<script>
	import {eventBus} from "../app";

	export default {
		name: 'ImageUploader',
		props: {
			dataPath: {
				type: String
			},
			dataPostUrl: {
				type: String
			},
			dataImage: {
				type: String,
				required: false
			},
			dataTitle: {
				type: String
			},
			dataModelId: {
				type: Number
			}
		},
		data() {
			return {
				postUrl: this.dataPostUrl,
				path: this.dataPath,
				modelId: this.dataModelId,
				title: this.dataTitle,
				image: this.dataImage ? this.dataImage : null,
				file: '',
				inProgress: false
			}
		},
		methods: {
			handleFileUpload: function () {
				this.inProgress = true;
				if (this.image) {
					this.file = this.$refs.fileChange.files[0];
				} else {
					this.file = this.$refs.file.files[0];
				}

				if (this.file) {
					eventBus.$emit('onLoaderStart');
					let reader = new FileReader();

					reader.onload = (e) => {
						this.image = e.target.result;

						let formData = new FormData();

						formData.append('file', this.file);

						axios.post('/api/' + this.$selectedSite.slug + this.path + this.modelId + this.postUrl,
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							}
						).then(response => {
							eventBus.$emit('onLoaderFinish');
							if (response.data.success) {
								this.$toastr.success('Image uploaded successful.', 'Success');
							} else {
								this.$toastr.error('Image uploaded failed.', 'Error');
							}
							this.inProgress = false;
						}).catch(e => {
							eventBus.$emit('onLoaderFinish');
							this.$toastr.error('Image uploaded failed.', 'Error');
						});
					};
					reader.readAsDataURL(this.file);
				}
			}
		}
	}
</script>

<style scoped>

</style>
